module.exports = __webpack_public_path__ + "img/clara-barton.4aa66cc9.png";